import _ from 'lodash';
import styled from 'styled-components';
import { CgFormatSlash } from 'react-icons/cg';

const WidgetBreadcrumb = ({ data = null, ...props }) => {
  if (_.isEmpty(data)) return null;
  const _data = [
    {
      icon: null,
      nameTh: 'Home',
      nameEng: 'Home',
      link: null
    },
    {
      icon: <CgFormatSlash />,
      nameTh: data?.section?.th,
      nameEng: data?.section?.en,
      link: `/category/${data?.section?.en || ''}`
    },
    {
      icon: <CgFormatSlash />,
      nameTh: data?.subCategory?.th,
      nameEng: data?.subCategory?.en,
      link: `/category/${data?.section?.en || ''}/${data?.subCategory?.en || ''}`
    }
  ];
  // console.log('WidgetBreadcrumb', _data);
  return (
    <>
      <WidgetWrapper id='widget-breadcrumb' className='breadcrumb-title' {...props}>
        <div aria-label='breadcrumb' className='container'>
          <ul className='breadcrumb'>
            {_data.map(
              (item, index) =>
                item.nameTh && (
                  <li key={index} className='breadcrumb-item'>
                    {item.icon}
                    {item.link ? <a href={item.link}>{item?.nameTh}</a> : <a href='/'>{item?.nameTh}</a>}
                  </li>
                )
            )}
          </ul>
        </div>
      </WidgetWrapper>
    </>
  );
};

const WidgetWrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: #f0f0f0;
  padding: 15px 0;
  margin-top: -30px;
  text-transform: uppercase;
  @media (max-width: 690px) {
    background-color: #fff;
  }
  ul.breadcrumb {
    display: flex;
    a {
      color: #6f6f6f;
      font-weight: 300;
      font-size: 12px;
      &:hover {
        color: rgba(0, 0, 0);
      }
    }
    svg {
      color: #6f6f6f;
      font-weight: 300;
      font-size: 16px;
      margin: 0 6px;
    }
    .breadcrumb-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
  }
  @media (max-width: 768px) {
    /* margin: .75rem 0; */
    ul.breadcrumb {
      a {
        font-size: 12px;
      }
    }
  }
`;

export default WidgetBreadcrumb;
